export enum ScoreCriteria {
    INCONSISTENCIES = 'inconsistencies',
    BETTER_LOCAL_COMPETITORS = 'better_local_competitors',
    REVIEW_COUNT = 'review_count',
    INSTAGRAM_VISIBILITY = 'instagram_visibility',
}
